import script from "./editeStockAllocationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./editeStockAllocationForm.vue?vue&type=script&setup=true&lang=js"

import "./editeStockAllocationForm.vue?vue&type=style&index=0&id=e04c449e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e04c449e"]])

export default __exports__